import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { toggleWarningModal } from 'src/actions/homeowner'
import { selectWarnings } from 'src/store/selectors/home'

const WarningModalContainer = compose(
  connect(
    state => ({
      ...selectWarnings(state)
    }),
    dispatch => ({
      toggle: () => dispatch(toggleWarningModal())
    })
  ),
  injectIntl
)

export default WarningModalContainer
